export type UploadItemStatus = 'pending' | 'uploading' | 'success' | 'error';

/** Per-upload request parameters (can differ for each batch/file). */
export interface UploadParams {
  company_id?: number;
  property_id: number;
  building_ids: number[];
}

export interface UploadItem {
  id: string;
  file: File;
  fileName: string;
  fileSize: number;
  property_id: number;
  building_ids: number[];
  progress: number;
  status: UploadItemStatus;
  message?: string;
}

export enum UploadCityBillErrorIds {
  SUCCESS = 'success',
  QUEUED = 'queued',
  DUPLICATED = 'duplicated'
}

export interface UploadCityBillResponse {
  error: UploadCityBillErrorIds;
  message: string;
  filename: string;
}

export interface CityBillsUploaderProps extends UploadParams {
  maxFiles?: number;
  /** Only used when no app-level CityBillsUploadProvider exists */
  apiBaseUrl?: string;
}
